module.exports = __webpack_public_path__ + "bb4dbfa384fb047ae6e0e3e84a921afe.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-1050.webp.png
// module id = 200
// module chunks = 0